import React from "react";
import { Box, Typography, Button } from "@mui/material";
import cartEmptyIcon from "../../assets/svg/cart-empty.svg";
import { useNavigate } from "react-router";

const CartEmpty = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="80vh"
      textAlign="center"
      px={2}
    >
      <Box
        component="img"
        src={cartEmptyIcon}
        alt="Empty Cart"
        width={200}
        height={200}
        mb={2}
      />
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontSize: 20, fontWeight: 600, lineHeight: "150%" }}
      >
        Your Cart is Empty
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: 16,
          fontWeight: 500,
          lineHeight: "150%",
          color: "var(--neutral-700)",
        }}
        mb={4}
      >
        Fill it with joyous choices and delightful finds.
      </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "var(--primary-red-base)",
          color: "white",
          px: 4,
          py: 1.25,
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 600,
          fontSize: 14,
        }}
        onClick={() => navigate("/")}
      >
        Continue Shopping
      </Button>
    </Box>
  );
};

export default CartEmpty;
